/**
 * OfflineError - thrown when a request fails due to network unavailability
 * and no cached data is available.
 *
 * If cached data IS available, the ApiClient returns the cached response
 * transparently. OfflineError is only thrown when there is no fallback.
 */
export class OfflineError extends Error {
  readonly isOffline = true

  constructor(message: string = 'You are offline and no cached data is available for this request.') {
    super(message)
    this.name = 'OfflineError'
  }

  /** Check if an error is a network failure (fetch TypeError). */
  static isNetworkError(error: unknown): boolean {
    return error instanceof TypeError && (
      error.message === 'Failed to fetch' ||
      error.message === 'NetworkError when attempting to reach resource.' || // Firefox
      error.message.includes('network') ||
      error.message.includes('Network request failed')
    )
  }
}
